<template>
  <footer class="site-footer">
    <div class="shell footer-links">
      <div>
        <SiteLogo />
        <p>Видеонаблюдение, которое работает<br />на ваше спокойствие.</p>
      </div>
      <nav aria-label="Оборудование">
        <h3>Оборудование</h3>
        <NuxtLink to="/products">Каталог товаров</NuxtLink
        ><NuxtLink to="/#packages">Готовые комплекты</NuxtLink
        ><NuxtLink to="/cart">Ваша корзина</NuxtLink>
      </nav>
      <nav aria-label="Решения">
        <h3>Решения</h3>
        <NuxtLink to="/#solutions">Для дома и бизнеса</NuxtLink
        ><NuxtLink to="/services">Установка и настройка</NuxtLink
        ><NuxtLink to="/calculator">Планирование системы</NuxtLink>
      </nav>
      <nav aria-label="О Robotics Vision">
        <h3>Robotics Vision</h3>
        <NuxtLink to="/#system">Собственная система</NuxtLink
        ><NuxtLink to="/partnership">Сотрудничество</NuxtLink
        ><NuxtLink to="/contacts">Контакты</NuxtLink
        ><NuxtLink to="/#faq">Вопросы и ответы</NuxtLink>
      </nav>
    </div>
    <div class="shell footer-bottom">
      <span>© {{ year }} Robotics Vision</span><span>Санкт-Петербург и Ленинградская область</span
      ><NuxtLink to="/privacy">Конфиденциальность</NuxtLink>
    </div>
  </footer>
</template>
<script setup lang="ts">
const year = new Date().getFullYear();
</script>
